module.exports = __webpack_public_path__ + "static/Parisienne-Regular-ad4cd34327721459c11a67b4332c945e.ttf";